import React, { useState, useEffect } from 'react';

const SocialBar: React.FC = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const controlSocialBar = () => {
      if (typeof window !== 'undefined') {
        const currentScrollY = window.scrollY;
        
        // Show social bar when scrolling up or at top
        if (currentScrollY < lastScrollY || currentScrollY < 10) {
          setIsVisible(true);
        } else {
          // Hide social bar when scrolling down
          setIsVisible(false);
        }
        
        setLastScrollY(currentScrollY);
      }
    };

    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', controlSocialBar);
      
      return () => {
        window.removeEventListener('scroll', controlSocialBar);
      };
    }
  }, [lastScrollY]);

  return (
    <div 
      className={`fixed top-0 left-0 right-0 z-50 bg-gray-800 text-white transition-transform duration-300 hidden md:block ${
        isVisible ? 'translate-y-0' : '-translate-y-full'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-10">
          {/* Social Media Icons */}
          <div className="flex items-center space-x-3">
            <a 
              href="https://www.facebook.com/share/1Hs21UgYzh/?mibextid=wwXIfr" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-white hover:text-gray-300 transition-colors"
              aria-label="Facebook"
            >
              <div className="w-6 h-6 bg-blue-600 rounded-full flex items-center justify-center">
                <svg className="w-3 h-3 fill-current" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </div>
            </a>
            <a 
              href="https://t.me/signaturestylesmm" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-white hover:text-gray-300 transition-colors"
              aria-label="Telegram"
            >
              <div className="w-6 h-6 bg-sky-500 rounded-full flex items-center justify-center">
                <svg className="w-3 h-3 fill-current" viewBox="0 0 24 24">
                  <path d="M9.78 18.65l.28-4.23 7.68-6.92c.34-.31-.07-.46-.52-.19L7.74 13.3 3.31 11.95c-.51-.16-.52-.53.11-.74l14.8-5.7c.45-.17.85.13.66.76l-2.69 12.8c-.19.91-.74 1.13-1.51.7z"/>
                </svg>
              </div>
            </a>
            <a 
              href="https://wa.me/+959943000730" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-white hover:text-gray-300 transition-colors"
              aria-label="WhatsApp"
            >
              <div className="w-6 h-6 bg-green-500 rounded-full flex items-center justify-center">
                <svg className="w-3 h-3 fill-current" viewBox="0 0 24 24">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488"/>
                </svg>
              </div>
            </a>
            <a 
              href="viber://chat?number=%2B959943000730" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-white hover:text-gray-300 transition-colors"
              aria-label="Viber"
            >
              <div className="w-6 h-6 bg-purple-600 rounded-full flex items-center justify-center">
                <svg className="w-4 h-4 fill-current" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 512.002 512.002" xmlSpace="preserve">
                  <g>
                    <path d="M437.976,214.854c0.615-72.186-60.866-138.361-137.051-147.512c-1.515-0.18-3.166-0.453-4.913-0.743 c-3.772-0.625-7.672-1.267-11.607-1.267c-15.614,0-19.788,10.968-20.887,17.51c-1.069,6.36-0.049,11.701,3.024,15.882 c5.171,7.031,14.269,8.279,21.577,9.28c2.142,0.296,4.163,0.571,5.855,0.951c68.449,15.295,91.497,39.341,102.761,107.208 c0.275,1.658,0.399,3.702,0.531,5.869c0.491,8.113,1.515,24.991,19.661,24.991h0.002c1.511,0,3.134-0.13,4.824-0.388 c16.898-2.568,16.368-17.996,16.114-25.409c-0.072-2.088-0.14-4.063,0.037-5.376C437.95,215.519,437.974,215.186,437.976,214.854z"></path>
                    <path d="M279.974,40.846c2.027,0.146,3.947,0.286,5.545,0.531c112.4,17.286,164.091,70.54,178.416,183.819 c0.243,1.926,0.281,4.274,0.321,6.761c0.143,8.85,0.437,27.262,20.21,27.643l0.614,0.006c6.201,0,11.134-1.87,14.662-5.562 c6.155-6.438,5.726-16.002,5.379-23.689c-0.084-1.886-0.165-3.662-0.145-5.217C506.405,109.283,406.12,4.226,290.369,0.32 c-0.48-0.016-0.938,0.01-1.401,0.075c-0.227,0.033-0.649,0.075-1.371,0.075c-1.154,0-2.574-0.1-4.08-0.202 C281.696,0.143,279.632,0,277.54,0c-18.434,0-21.938,13.102-22.386,20.912C254.12,38.963,271.582,40.233,279.974,40.846z"></path>
                    <path d="M458.511,371.602c-2.39-1.825-4.861-3.714-7.174-5.578c-12.272-9.876-25.328-18.979-37.955-27.783 c-2.62-1.825-5.241-3.652-7.852-5.484c-16.174-11.361-30.715-16.882-44.453-16.882c-18.504,0-34.636,10.224-47.951,30.384 c-5.899,8.938-13.056,13.283-21.876,13.283c-5.215,0-11.142-1.488-17.612-4.425c-52.207-23.674-89.486-59.972-110.803-107.886 c-10.305-23.158-6.964-38.295,11.172-50.615c10.299-6.99,29.469-20.003,28.111-44.922c-1.538-28.298-63.976-113.445-90.284-123.115 c-11.138-4.096-22.841-4.134-34.846-0.095C46.744,38.651,25.041,56.506,14.219,80.115c-10.458,22.813-9.986,49.599,1.366,77.463 C48.401,238.14,94.538,308.38,152.72,366.342c56.95,56.74,126.946,103.217,208.042,138.137c7.31,3.145,14.977,4.861,20.575,6.112 c1.908,0.429,3.555,0.795,4.756,1.124c0.66,0.18,1.34,0.277,2.023,0.283l0.641,0.003c0.002,0,0,0,0.003,0 c38.142,0,83.941-34.854,98.007-74.59C499.09,402.618,476.59,385.42,458.511,371.602z"></path>
                    <path d="M296.845,132.872c-6.53,0.165-20.121,0.502-24.889,14.344c-2.231,6.468-1.964,12.084,0.795,16.692 c4.048,6.761,11.805,8.833,18.86,9.97c25.586,4.106,38.726,18.254,41.354,44.522c1.221,12.248,9.469,20.801,20.059,20.801h0.002 c0.782,0,1.582-0.046,2.379-0.143c12.736-1.515,18.911-10.873,18.353-27.81c0.204-17.677-9.047-37.745-24.781-53.73 C333.187,141.484,314.156,132.454,296.845,132.872z"></path>
                  </g>
                </svg>
              </div>
            </a>
            <a 
              href="https://www.tiktok.com/@signaturestylesmm" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-white hover:text-gray-300 transition-colors"
              aria-label="TikTok"
            >
              <div className="w-6 h-6 bg-black rounded-full flex items-center justify-center">
                <svg className="w-3 h-3 fill-current" viewBox="0 0 24 24">
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
                </svg>
              </div>
            </a>
          </div>
          
          {/* Contact Info & Sign In */}
          <div className="flex items-center space-x-6 text-sm">
            <div className="hidden md:flex items-center space-x-4">
              <span className="text-gray-300">✉️ info@signaturestylesmm.com</span>
              <span className="text-gray-300">☏ (+95)9943000730</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SocialBar;
